export type OrderStatus =
  | 'PENDING_PAYMENT'
  | 'PAID'
  | 'ACCEPTED'
  | 'IN_PROGRESS'
  | 'READY'
  | 'SERVED'
  | 'PICKED_UP'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'REFUNDED'
  | 'VOIDED';

export const ORDER_STATUS_SEQUENCE: OrderStatus[] = [
  'PENDING_PAYMENT',
  'PAID',
  'ACCEPTED',
  'IN_PROGRESS',
  'READY',
  'SERVED',
  'PICKED_UP',
  'COMPLETED',
  'CANCELLED',
  'REFUNDED',
  'VOIDED',
] as const;

export const ORDER_IN_FLIGHT_STATUSES: OrderStatus[] = [
  'PENDING_PAYMENT',
  'PAID',
  'ACCEPTED',
  'IN_PROGRESS',
  'READY',
] as const;

export const ORDER_TERMINAL_STATUSES: OrderStatus[] = [
  'COMPLETED',
  'CANCELLED',
  'REFUNDED',
  'VOIDED',
] as const;

export const ORDER_GUEST_VISIBLE_STATUSES: OrderStatus[] = [
  'PENDING_PAYMENT',
  'PAID',
  'ACCEPTED',
  'IN_PROGRESS',
  'READY',
  'PICKED_UP',
  'COMPLETED',
  'CANCELLED',
] as const;

export const ORDER_REVERSIBLE_STATUSES: OrderStatus[] = [
  'PAID',
  'ACCEPTED',
  'IN_PROGRESS',
  'READY',
  'SERVED',
  'PICKED_UP',
  'COMPLETED',
] as const;
